import { Autoplay, Navigation } from 'swiper';
import {swiperOnResize} from '../../../../src/js/utils/swiperOnResize.utils';

let ourSectorsSwiperWr = document.querySelectorAll('.our-sectors-swiper-wr');
ourSectorsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    swiperOnResize('(min-width: 993px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 1,
          spaceBetween: 16,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          breakpoints: {
            990: {
              slidesPerView: 2.8,
            },
            1023: {
              slidesPerView: 3.5,
            },
            1200: {
              slidesPerView: 4,
            },
            1380: {
              slidesPerView: 5,
            }
          },
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
        },
    );
  }
});